import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import 'bulma/css/bulma.css';
import 'bulma-quickview/dist/css/bulma-quickview.min.css';
import '@fortawesome/fontawesome-free/css/all.css';
import bulmaQuickview from 'bulma-quickview/src/js';
import { FontAwesomeIcon } from './fontawesome';
import Vuelidate from '@vuelidate/core'; // Import the default export

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
axios.defaults.headers.common['Authorization'] = `Token ${localStorage.getItem('token')}`;

const app = createApp(App);

app.use(store);
app.use(router);
app.use(Vuelidate); // Use Vuelidate as a plugin

app.component('font-awesome-icon', FontAwesomeIcon);

// Initialize Bulma Quickview
document.addEventListener('DOMContentLoaded', () => {
  bulmaQuickview.attach();
});

app.mount('#app');

